"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useMemo } from "react";
type WaveDropLayerContextValue = {
  readonly mobileMenuZIndexClassName: string;
  readonly mobileDialogZIndexClassName: string;
};
const DEFAULT_WAVE_DROP_LAYER_CONTEXT: WaveDropLayerContextValue = {
  mobileMenuZIndexClassName: "tw-z-[1000]",
  mobileDialogZIndexClassName: "tw-z-[1010]"
};
const WaveDropLayerContext = createContext<WaveDropLayerContextValue>(DEFAULT_WAVE_DROP_LAYER_CONTEXT);
export function WaveDropLayerProvider(t0) {
  const $ = _c(6);
  const {
    children,
    value
  } = t0;
  const t1 = value?.mobileMenuZIndexClassName ?? DEFAULT_WAVE_DROP_LAYER_CONTEXT.mobileMenuZIndexClassName;
  const t2 = value?.mobileDialogZIndexClassName ?? DEFAULT_WAVE_DROP_LAYER_CONTEXT.mobileDialogZIndexClassName;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      mobileMenuZIndexClassName: t1,
      mobileDialogZIndexClassName: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const mergedValue = t3;
  let t4;
  if ($[3] !== children || $[4] !== mergedValue) {
    t4 = <WaveDropLayerContext.Provider value={mergedValue}>{children}</WaveDropLayerContext.Provider>;
    $[3] = children;
    $[4] = mergedValue;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
export function useWaveDropLayers() {
  return useContext(WaveDropLayerContext);
}